<template>
  <div class="wrap">
    <Header />
    <div class="main">
      <div class="banbox">
        <img src="../assets/aotuo/abubanner.png" alt="">
        <p>关于我们</p>
      </div>
      <div class="introduce">
        <p>品牌介绍</p>
        <div class="content">
          <div class="imgbox">
            <img src="../assets/aotuo/abu1.png" alt="">
            <img src="../assets/aotuo/abu2.png" alt="">
          </div>
          <div class="textbox">
            <p>我们是一家专注于软件系统开发和技防技控一站式解决方案的高科技公司。在AI算法领域深耕多年，我们致力于提升人工智能的可解释性、公平性以及数据及隐私安全，秉承着“共谋、共创、共赢”的经营理念，践行“创造价值、学习、责任”的核心价值观，我们坚持为社会创造价值，让技术服务生活。</p>
            <p>我们始终以客户需求为导向，以技术应用为核心，以大数据可视化为基础，为粮仓、烟草、银行、煤矿、工厂、电力、税务、公安和消防等多个行业提供数字化智能安全预警平台和智能管理解决方案。</p>
            <p>我们的目标是助力各行业终端用户完成智能化转型升级，加速人工智能技术的落地。在OTTO机器人网站上，您可以找到最新的工业机器人技术应用案例、解决方案推荐以及行业动态分析！</p>
          </div>
        </div>
      </div>
      <div class="numeral">
        <div class="title">
          <p>为什么选择我们？</p>
          <span>卓越的市场竞争力和品牌影响力</span>
        </div>
        <div class="numeralcont">
          <div class="numeralbox">
            <p>60+</p>
            <span>畅销国家和地区</span>
            <p>70000</p>
            <span>机器人累计销量近</span>
          </div>
          <div class="numeralbox">
            <p>300+</p>
            <span>全国服务网点</span>
            <p>40000+</p>
            <span>场景入驻门店数</span>
          </div>
          <div class="numeralbox">
            <p>1400+</p>
            <span>已申请核心技术专利</span>
            <p>80%</p>
            <span>TOP100餐饮客户使用率</span>
          </div>
        </div>
      </div>
      <div class="partners">
        <div class="title">
          <p>战略合作伙伴</p>
          <span>持续为行业创新与高质量发展提供新动力</span>
        </div>
        <div class="imgbox">
          <img src="../assets/aotuo/hb.png" alt="">
        </div>
      </div>
      <div class="lastone">
        <div class="leftbox">
          <div class="boxcont">
            <p>奥托机器人期待与你</p> 
            <p>携手共赢</p> 
            <!-- <div class="detailbtn">
              查看详情 →
            </div> -->
          </div>
        </div>
        <div class="rightbox">
          <img src="../assets/aotuo/rightimg.png" alt="">
        </div>
      </div>
    </div>
    <Sidebar />
    <Footer />
  </div>
</template>
<script>
import Header from "../components/Head";
import Sidebar from "../components/Sidebar.vue";
import Footer from "../components/Footer";

export default {
  name: "AboutUs",
  components: {
    Header,
    Sidebar,
    Footer,
  },
  data() {
    return {
      launage: "",
    };
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {},
};
</script>
<style lang="less" scoped>
.main {
  width: 100%;
  margin: auto;
}
.banbox{
  width: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  img{
    width: 100%;
  }
  p{
    color:#ffffff;
    font-size:56px;
    position: absolute;
    z-index: 9;
    border-bottom: 3px solid #fff;
    text-align: center;
    padding: 26px 0;
  }
}
.introduce{
  width: 1200px;
  height: 800px;
  margin: auto;
  margin-top: 60px;
  p{
      font-weight:600;
      color:#000000;
      font-size:40px;
      text-align: center;
  }
  .content{
    display: flex;
    justify-content: space-between;
    margin-top: 76px;
    .imgbox{
      flex: 1;
      position: relative;
      img:nth-child(1){
        width: 390px;
        position: absolute;
      }
      img:nth-child(2){
        width: 268px;
        position: absolute;
        z-index: 9;
        top: 176px;
        left: 248px;
      }
    }
    .textbox{
      flex: 1;
      margin-top: 76px;
      p{
        color:#474747;
        font-size:16px;
        line-height:30px;
        text-align: left;
        margin-bottom: 30px;
      }
    }
  }
}
.title {
  p{
    font-weight:600;
    color:#000000;
    font-size:40px;
    letter-spacing:2.63px;
    margin-bottom: 10px;
    text-align: center;
    line-height:56px;
  }
  span{
    color:#474747;
    font-size:14px;
    letter-spacing:0.92px;
    line-height:20px;
    display: block;
    text-align: center;
  }
 
}
.numeral{
  background:#f5f6fa;
  padding-top: 80px;
  .numeralcont{
    width: 1200px;
    margin: auto;
    margin-top: 20px;
    display: flex;
    justify-content: space-around;
    .numeralbox{
      p{
        font-weight:700;
        color:#0039c6;
        font-size:60px;
        letter-spacing:3.95px;
        margin-top: 40px;
      }
      span{
        color:#474747;
        font-size:14px;
        letter-spacing:0.92px;
      }
    }
  }
}

.partners{
  background:#f5f6fa;
  padding-top: 100px;
  .imgbox{
    width: 1200px;
    margin: auto;
    img{
      width: 100%;
    }
  }
}
.lastone{
  display: flex;
  height: 400px;
  background:#0039c6;
  .leftbox{
    width: 40%;
    padding-top: 106px;
    .boxcont{
      margin: auto;
      width: 290px;
      height: 300px;
      p{
        font-family:PingFang SC;
        font-weight:600;
        color:#ffffff;
        font-size:30px;
        letter-spacing:1.97px;
      }
      .detailbtn{
        width:144px;
        height:48px;
        background:#ffffff;
        color:#0039c6;
        font-size:16px;
        text-align: center;
        line-height: 48px;
        margin-top: 50px;
      }
    } 
  }
  .rightbox{
    width: 60%;
    img{
      width: 100%;
      height: 100%;
    }
  }
}

</style>
